import React from "react";

const STEP_LABELS = {
  path: "Choose path",
  use_case: "Use case",
  user_type: "Your role",
  company_name: "Company name",
  monthly_volume: "Monthly volume",
  api_request_volume: "API requests",
  api_usage: "API usage",
  goals: "Goals",
};

export default function ProgressIndicator({ currentStep, totalSteps, progress, steps = [] }) {
  return (
    <div className="mb-6 sm:mb-8">
      <div className="mb-2 h-1 w-full overflow-hidden rounded-full bg-hairline">
        <div
          className="h-full rounded-full bg-primary-700 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
          role="progressbar"
          aria-valuenow={Math.round(progress)}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>

      <div className="mb-1.5 flex items-center justify-between font-Mulish text-sm text-graphite">
        <span>Step {currentStep} of {totalSteps}</span>
        <span>{Math.round(progress)}% complete</span>
      </div>

      {steps.length > 0 && (
        <div className="flex flex-wrap gap-x-3 gap-y-1 font-Mulish text-xs">
          {steps.map((step, i) => (
            <span
              key={step.id}
              className={i === currentStep - 1 ? "font-semibold text-secondary" : "text-graphite"}
            >
              {i + 1}. {STEP_LABELS[step.id] || step.question?.slice(0, 20) || step.id}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
